import { motion } from "framer-motion";

const CHAPTERS = [
  {
    num: "01",
    title: "Obsessive by nature",
    body:
      "We treat every vessel as if it were our own. No shortcuts, no spray-and-pray — just methodical, hand-worked care that respects the craft of the boat and the owner behind it.",
  },
  {
    num: "02",
    title: "Marine-grade, always",
    body:
      "Salt, sun and water are relentless. So are our products. We use only marine-formulated compounds, sealants and protectants engineered to hold up on the water — not just look good on day one.",
  },
  {
    num: "03",
    title: "A collective, not a crew",
    body:
      "Consistent, vetted detailers who show up on schedule and remember your boat. Book once or join a maintenance plan — either way you get the same standard, every visit.",
  },
];

const fade = {
  hidden: { opacity: 0, y: 40 },
  show: { opacity: 1, y: 0, transition: { duration: 0.9, ease: [0.22, 1, 0.36, 1] } },
};

export default function Manifesto() {
  return (
    <section id="ethos" className="relative bg-black py-28 md:py-40" data-testid="manifesto-section">
      <div className="mx-auto max-w-[1400px] px-5 md:px-10">
        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-100px" }}
          variants={fade}
          className="mb-20 md:mb-28 max-w-3xl"
        >
          <p className="mb-6 text-xs uppercase tracking-mega text-gold">The Ethos</p>
          <h2 className="font-serif font-light leading-[0.95] tracking-tight text-4xl md:text-6xl text-white">
            Detailing is not a chore.
            <br />
            It is <span className="text-gold-gradient italic">stewardship.</span>
          </h2>
        </motion.div>

        <div className="flex flex-col">
          {CHAPTERS.map((c, i) => (
            <motion.div
              key={c.num}
              initial="hidden"
              whileInView="show"
              viewport={{ once: true, margin: "-80px" }}
              variants={fade}
              className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-10 border-t border-white/10 py-12 md:py-16"
              data-testid={`manifesto-chapter-${c.num}`}
            >
              <div className="md:col-span-3">
                <span className="font-serif text-6xl md:text-8xl text-white/10 leading-none">{c.num}</span>
              </div>
              <h3 className="md:col-span-4 font-serif text-3xl md:text-4xl text-white font-light leading-tight">
                {c.title}
              </h3>
              <p className="md:col-span-5 text-base md:text-lg font-light text-white/60 leading-relaxed">
                {c.body}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
